import { render, staticRenderFns } from "./StareAtPage.vue?vue&type=template&id=ceb4391c&scoped=true"
import script from "./StareAtPage.vue?vue&type=script&lang=js"
export * from "./StareAtPage.vue?vue&type=script&lang=js"
import style0 from "./StareAtPage.vue?vue&type=style&index=0&id=ceb4391c&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb4391c",
  null
  
)

export default component.exports